module.exports = __webpack_public_path__ + "img/1.60921a1c.jpg";